<template>

  <form class="cr-form" @submit.prevent="handleSearch" autocomplete="off">
    <div class="cr-search-field">
      <button class="cr-search-field__button" type="submit" aria-label="Найти">
        <svg class="cr-search-field__button-icon" width="20" height="20" viewBox="0 0 20 20">
          <use xlink:href="/assets/img/svg/sprite.svg#icon-search"></use>
        </svg>
      </button>
      <input class="cr-search-field__input js-input-search" type="search" name="q" placeholder="Поиск по каталогу" v-model="searchQuery">
      <button class="cr-search-field__button-delete js-button-delete" type="button">
        <svg class="cr-search-field__icon-delete" width="20" height="20" viewBox="0 0 25 25">
          <use xlink:href="/assets/img/svg/sprite.svg#icon-cross-3"></use>
        </svg>
      </button>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      searchQuery: '',
    }
  },
  computed: {

  },
  created() {
    this.searchQuery = this.$route.query.q;
  },
  methods: {
    handleSearch() {
      if (this.searchQuery.trim()) {
        this.$router.push({
          path: '/category/search/',
          query: { q: this.searchQuery }
        });
      }
    }
  }
}
</script>